class Form {
	needConfirm = false;
	confirmed = false;
	autoSubmit = false;

	$form;
	$button;
	$inputs;
	$inputsReq;
	$countdown = null;
	$reset;
	$resend = null;
	$error;
	$success;
	$codeInput;
	$codeCells;
	$onSuccess;

	buttonActive;
	focusedInput = null;
	isOrientationChanging = false;
	orientationChangeTimeout = null;

	countdownId = '';
	countdownSeconds = 0;
	countdownIsActive = false;

	codeInputInitialized = false;

	constructor($form) {
		this.$form = $form;
		this.$button = $form.find('button, .js-submit');
		this.$inputs = $form.find('input, textarea, select');
		this.$inputsReq = this.$inputs.filter('[required]');
		this.$reset = $form.find('.js-reset');
		this.$error = $form.find('.js-error');
		this.$success = $form.find('.js-success');
		this.$codeInput = $form.find('[name="code"]');
		this.$codeCells = $form.find('.js-code-cell');

		this.needConfirm = typeof this.$button.attr('data-confirm') != 'undefined';
		this.autoSubmit = typeof this.$button.attr('data-auto-submit') != 'undefined';

		this.$countdown = $form.find('.js-countdown');
		this.$resetRow = $form.find('.js-reset-row');
		this.$resend = $form.find('.js-resend');

		if (this.$countdown.length) {
			this.countdownId = this.$countdown.find('span').attr('id');
			this.countdownSeconds = parseInt(this.$countdown.data('seconds')) || 0;

			if (!this.countdownSeconds)
				console.error('Для элемента "обратный отсчет" не задан атрибут data-seconds="int"');

			this.restoreCountdown();
		}

		//Назначение событий
		this.$form.on('submit', this.onFormSubmit.bind(this));
		this.$inputsReq.on('keyup change', this.onInputReqChange.bind(this));
		this.$reset.on('click', this.onResetClick.bind(this));
		this.$form.find('.js-resend').on('click', this.onResendClick.bind(this));

		//События для отслеживания фокуса
		this.$form.on('focusin', 'input, textarea, select', this.onInputFocus.bind(this));
		this.$form.on('focusout', 'input, textarea, select', this.onInputBlur.bind(this));

		this.$form.addClass('ok');

		this.onInputReqChange(); //Для активации кнопки в начале работы
		this.initOrientationHandler(); //Обработчик изменения ориентации

		return this;
	}

	//-------------------------------------------------
	//Отправить на сервер сообщение об ошибке
	logError(error, serverResponse, context) {
		const errorData = {
			error: {
				message: error.message || error.toString(),
				name: error.name || 'Unknown',
				stack: error.stack || '',
			},
			serverResponse: {
				content: serverResponse,
				type: typeof serverResponse,
				length: serverResponse ? serverResponse.length : 0
			},
			context: context,
			userAgent: navigator.userAgent,
			url: window.location.href,
			formAction: this.$form.attr('action') || '',
			timestamp: new Date().toISOString()
		};

		BX.ajax.post('/system/formlog.php', {
			type: 'form_error',
			data: JSON.stringify(errorData)
		});
	}

	//-------------------------------------------------
	//Изменить активность формы
	active(flag = true) {
		this.$form.toggleClass('form-disabled', !flag);

		if (flag) {
			const inputToFocus = (this.focusedInput && this.focusedInput.length)
				? this.focusedInput
				: this.$inputs.filter(':visible').not('[type="hidden"]').first();
			inputToFocus.focus();
		} else
			this.changeButtonActive(false);
	}

	//-------------------------------------------------
	//Инициализация поля для кода из 4 позиций
	initCodeInput() {
		if (this.codeInputInitialized)
			return;

		this.codeInputInitialized = true;

		const
			self = this,
			$cells = self.$codeCells;

		$cells.first().focus();
		this.focusedInput = $cells.first();

		$cells.on({
			input() {
				const
					$this = $(this),
					value = ($this.val() || '').replace(/\D/g, ''),
					i = Number($this.data('index'));

				// Несколько цифр — раскидать по ячейкам
				if (value.length > 1) {
					value.split('').forEach(function(digit, offset) {
						const $cell = $cells.eq(i + offset);

						if (!$cell.length)
							return;

						$cell.val(digit);
						$cell.toggleClass('filled', true);
					});

					const
						nextIndex = Math.min(i + value.length, $cells.length - 1),
						$target = $cells.eq(nextIndex);

					$target.focus();
					self.focusedInput = $target;
				}

				// Одиночный ввод
				else {
					$this.val(value[0] || '');
					$this.toggleClass('filled', !!value[0]);

					if (value) {
						const $next = $cells.eq(i + 1);

						if ($next.length) {
							$next.focus();
							self.focusedInput = $next;
						}
					}
				}

				self.updateCodeValue();
			},

			keydown(e) {
				const $this = $(this), i = +$this.data('index');
				const $prev = $cells.eq(i - 1), $next = $cells.eq(i + 1);

				// Backspace — очищаем/уходим влево
				if (e.key === 'Backspace') {
					if ($this.val()) $this.val('');
					else if ($prev.length) {
						$prev.val('').focus();
						self.focusedInput = $prev;
					}

					self.updateCodeValue();

					return;
				}

				// Стрелки
				if (e.key === 'ArrowLeft' && $prev.length) {
					$prev.focus();
					self.focusedInput = $prev;
				}
				if (e.key === 'ArrowRight' && $next.length) {
					$next.focus();
					self.focusedInput = $next;
				}
			},

			focus() {
				self.focusedInput = $(this);
			}
		});

		// Клик по контейнеру — фокус на первую пустую, иначе на последнюю
		$cells.parent().on('click', function () {
			const $empty = $cells.filter(function () {
				return !this.value;
			}).first();

			const $target = $empty.length ? $empty : $cells.last();

			$target.focus();
			self.focusedInput = $target;
		});
	}

	//-------------------------------------------------
	//Обновить значение скрытого поля с кодом
	updateCodeValue() {
		const code = this.$codeCells
			.map(function () {
				return this.value;
			})
			.get()
			.join('');

		this.$codeInput.val(code);
		this.onInputReqChange();

		if (code.length === 4 && this.autoSubmit) {
			this.$codeCells.prop('disabled', true);
			this.$form.submit();
		}
	}

	//-------------------------------------------------
	//Очистить поля кода
	clearCode() {
		this.$codeCells.val('').removeClass('filled');
		this.$codeCells.prop('disabled', false);
		this.$codeInput.val('');
		this.$codeCells.first().focus();
		this.focusedInput = this.$codeCells.first();
		this.onInputReqChange();
	}

	//-------------------------------------------------
	//Получить значение поля
	getValue($input) {
		var
			result = $input.val();

		if (result)
			result = result.trim();

		if ($input.attr('type') == 'checkbox')
			result = $input.prop('checked');

		return result;
	}

	//-------------------------------------------------
	//Пометить поле как ошибочное
	markError(name) {
		var
			$input = this.$inputs.filter(`[name="${name}"]`);

		$input.addClass('error');
		$input.closest('.input-label').addClass('error');
	}

	//-------------------------------------------------
	//Снять пометку ошибки с поля
	unmarkError(name) {
		var
			$input = this.$inputs.filter(`[name="${name}"]`);

		$input.removeClass('error');
		$input.closest('.input-label').removeClass('error');
	}

	//-------------------------------------------------
	//Запрос на активацию кнопки для возможности его отмены
	canEnableButton(mode) {
		return true;
	}

	//-------------------------------------------------
	//Изменить активность кнопки
	changeButtonActive(active) {
		var
			$native = this.$button.filter('button');

		$native.prop('disabled', !active);

		this.$button.not($native).toggleClass('disabled', !active);

		this.$form.trigger('formButtonActive', [active]);

		//Для внешних скриптов (возможность в любой момент узнать активность кнопки)
		this.buttonActive = active;
	}

	//-------------------------------------------------
	//Запустить проверку по SMS
	sendSms() {
		var
			self = this,
			data = {},
			$login = this.$inputsReq.filter('[name="login"]'),
			$type = this.$inputs.filter('[name="type"]'),
			$sessid = this.$inputs.filter('[name="sessid"]'),
			$surname = this.$inputs.filter('[name="surname"]'),  //Поле honey ловушка
			$recaptchaToken = this.$form.find('[name="g-recaptcha-response"]');  //recaptcha 2

		if (this.countdownId && this.countdownIsActive) {
			this.showError('Дождитесь пока не истечет время');

			return;
		}

		//Получение параметров из атрибута
		if (typeof self.$button.attr('data-urlparams') !== 'undefined')
			data = JSON.parse(
				'{"' + decodeURI(self.$button.attr('data-urlparams'))
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') + '"}'
			);

		if ($login.length) data.login = $login.val();
		if ($type.length) data.type = $type.val();
		if ($surname.length) data.surname = $surname.val();
		if ($sessid.length) data.sessid = $sessid.val();
		if ($recaptchaToken.length) data.gRecaptchaToken = $recaptchaToken.val();


		self.changeButtonActive(false);


		this.sendSmsRequest(data);

		//Добавляем токен рекапчи в запрос / recaptcha 3
		/*if (typeof grecaptcha !== 'undefined') {
			grecaptcha.ready(() => {
				var $script = $('script[src*="recaptcha/api.js"]');
				var siteKey = '';

				if ($script.length) {
					var match = $script.attr('src').match(/render=([^&]+)/);
					if (match && match[1]) {
						siteKey = match[1];
					}
				}

				if (siteKey) {
					grecaptcha.execute(siteKey, { action: 'submit' }).then((token) => {
						data.gRecaptchaToken = token;
						this.sendSmsRequest(data);
					});
				} else {
					console.error('ReCAPTCHA site key not found in script src');
					this.sendSmsRequest(data);
				}
			});
		} else {
			this.sendSmsRequest(data);
		}*/
	}
	//-------------------------------------------------
	//Отправляет запрос аякс на отправку данных sms
	//Вынесена в отдельный метод для запуска после инициализации рекапчи
	sendSmsRequest(data) {
		this.startCountdown();
		this.clearCode();

		this.$resend.hide();

		this.changeButtonActive(false);

		BX.ajax.post(
			'/local/ajax/forms/personal.sms.php',
			data,
			(result) => {
				try {
					result = JSON.parse(result);

					if(result.needRecaptcha) {
						window.initMyRecaptchas();
					}

					if (!result.result) {
						this.processResult(result);
						this.stopCountdown();
						this.$resetRow.show();
					}
					else {
						this.$form.find('.js-step-2').show();
						this.$reset.show();
						this.$resetRow.show();
						this.confirmed = true;
						this.initCodeInput();

						$('.recaptcha-wrapper').addClass('hide');

						if (this.$button.attr('data-step-2') ?? false) {
							const
								currentText = this.$button.text(),
								newText = this.$button.attr('data-step-2');

							this.$button.text(newText);
							this.$button.attr('data-step-2', currentText);
						}
					}
				}

				catch (error) {
					this.logError(error, result, 'sendSms_parse_error');
				}

				this.changeButtonActive(true);
			}
		);
	}

	//-------------------------------------------------
	//Запустить отправку данных
	send() {
		var
			self = this,
			data = self.$form.serialize();

		self.changeButtonActive(false);

		BX.ajax.post(
			self.$form.attr('action'),
			data,
			function (result) {
				try {
					result = JSON.parse(result);

					//Ошибка ввода sms-кода
					if (result.result == false) {
						if(self.$form.find('input[name="name"]').val()) { //Последний шаг регистрации
							let errorText = result.error.join(', ');
							if (!this.$errorDiv || !this.$errorDiv.parent().length) {
								this.$errorDiv = $('<div></div>')
									.text(errorText)
									.css({
										'color': '#ff4d4f',
										'padding': '10px',
									});
								this.$errorDiv.insertBefore(self.$form.find('button').parent());
							} else {
								this.$errorDiv.text(errorText);
							}
						}
						else {
							self.markError('code');
							self.clearCode();

							setTimeout(function () {
								self.unmarkError('code');
							}, 3000);
						}

					}
					else {
						if (this.$errorDiv) {
							this.$errorDiv.remove();
							this.$errorDiv = null; // Сбрасываем переменную
						}
					}

					self.processResult(result, {final: true});

				} catch (error) {
					self.logError(error, result, 'send_parse_error');
					self.changeButtonActive(true);
				}
			}
		)
	}

	//-------------------------------------------------
	//Вывести сообщение об успешной отправке
	successMessage(text) {
		if (!this.$success.length) return false;

		var
			$success = this.$success.clone(true);

		$success.html(text);

		if (text) this.$form.html('').append($success);
		else this.$success.fadeIn(250);
	}

	//-------------------------------------------------
	//Обработать результат отправки формы
	processResult(result, params = {}) {
		var
			self = this;

		//Обработка ошибки
		if (result.error) {
			if (typeof result.error != 'object')
				result.error = [result.error];

			self.showError(result.error.join('<br/>'));
			// self.$error
			// 	.html(result.error.join('<br/>'))
			// 	.addClass('active')
			// 	.fadeIn(100);
			//
			// setTimeout(function () {
			// 	self.changeButtonActive(true);
			//
			// 	self.$error
			// 		.html('')
			// 		.fadeOut(100, function () {
			// 			$(this).removeClass('active');
			// 		});
			// }, 3000);

			// Разблокируем поля кода при ошибке
			self.$codeCells.prop('disabled', false);
		}

		//Обработка истинного результата
		else {
			self.$form.trigger('form-submitEnd', [result]); // удалить, если не используется

			//Обнуляем счетчик
			self.stopCountdown();

			//Перезагрузка или перенаправление
			if (result.reload) {
				if (result.reload == true)
					location.reload();

				else if (result.popup)
					$.fancybox.open({
						src: result.reload,
						type: 'ajax'
					});

				else location.href = result.reload;
			}

			if (params.final || false) {
				//Вывод сообщения об успешной отправке
				if (
					this.autoSubmit ||
					(result.result && !result.reload)
				) {
					self.successMessage(result.success);

					setTimeout(() => this.backToStep1(), 2000);
				}
				else
					self.changeButtonActive(true);

				//Вызов событий
				self.$form.trigger('form-success', [result]);

				if (
					this.onSuccess &&
					typeof this.onSuccess === 'function'
				)
					this.onSuccess(result);
			}
		}
	}

	//-------------------------------------------------
	//Вернуться к первому шагу
	backToStep1() {
		this.$form.find('.js-step-2').hide();
		this.confirmed = false;
		this.needConfirm = true;

		// Очищаем код
		if (this.$codeCells.length)
			this.clearCode();

		// Swap обратно
		if (this.$button.attr('data-step-2')) {
			const
				currentText = this.$button.text(),
				originalText = this.$button.attr('data-step-2');

			this.$button.text(originalText);
			this.$button.attr('data-step-2', currentText);
		}

		this.$reset.hide();
		this.$resend.hide();
		this.$resetRow.hide();
		this.stopCountdown();

		this.codeInputInitialized = false;
	}

	//-------------------------------------------------
	// Полный сброс формы в начальное состояние
	reset() {
		this.backToStep1();

		// Очищаем все поля ввода
		this.$inputs.not('[type="hidden"]').each(function () {
			const $input = $(this);

			if ($input.attr('type') === 'checkbox')
				$input.prop('checked', false);

			else $input.val('').trigger('change');
		});

		this.changeButtonActive(false);

		this.$error.html('').removeClass('active').hide();
		this.$inputs.removeClass('error');
		this.$form.find('.input-label').removeClass('error');
	}

	//-------------------------------------------------
	//Событие отправки формы
	async onFormSubmit(event) {
		event.preventDefault();

		var isPromocodeChecked = await this.checkPromocode();

		if (!isPromocodeChecked)
			return false;

		if (this.needConfirm && !this.confirmed)
			this.sendSms();
		else
			this.send();

		return false;
	}

	//-------------------------------------------------
	//Событие изменения в обязательном поле
	onInputReqChange(_) {
		var
			self = this,
			canEnable = true;

		this.$inputsReq.filter(':visible, [type="checkbox"]').each(function () {
			if (!self.getValue($(this)))
				canEnable = false;
		});
		// console.log('canEnable1', canEnable, self.canEnableButton());

		canEnable = canEnable && self.canEnableButton();
		// console.log('canEnable2', canEnable);

		this.changeButtonActive(canEnable);
	}

	//-------------------------------------------------
	// Обработчик получения фокуса
	onInputFocus(event) {
		this.focusedInput = $(event.target);
	}

	//-------------------------------------------------
	// Обработчик потери фокуса (delegated)
	onInputBlur() {

		setTimeout(() => {
			if (this.isOrientationChanging) {
				return;
			}

			const active = document.activeElement;

			// Если фокус ушёл за пределы формы или на body — очищаем
			if (
				!active ||
				!this.$form[0].contains(active) ||
				active.tagName === 'BODY'
			)
				this.focusedInput = null;

		}, 120);
	}

	//-------------------------------------------------
	// Обработчик нажатия на кнопку сброса
	onResetClick(event) {
		event.preventDefault();

		this.reset();
	}

	//-------------------------------------------------
	// Обработчик нажатия на кнопку повторной отправки
	onResendClick(event) {
		event.preventDefault();
		this.sendSms();
	}

	//-------------------------------------------------
	//Инициализация обработчиков orientation/resize/visibility
	initOrientationHandler() {
		const self = this;

		// Сохраняем текущий фокус и через таймаут пробуем восстановить
		window.addEventListener('orientationchange', function () {
			self.isOrientationChanging = true;

			if (self.orientationChangeTimeout)
				clearTimeout(self.orientationChangeTimeout);

			self.orientationChangeTimeout = setTimeout(function () {
				self.isOrientationChanging = false;

				const cur = document.activeElement;

				if (
					!cur ||
					!self.$form[0].contains(cur)
					|| !$(cur).is('input, textarea, select')
				)
					self.restoreFocus();

			}, 350);
		});

		// Запасной обработчик
		window.addEventListener('resize', function () {
			if (self.orientationChangeTimeout)
				clearTimeout(self.orientationChangeTimeout);
			self.orientationChangeTimeout = setTimeout(function () {
				const cur = document.activeElement;
				if (
					(
						!cur ||
						!self.$form[0].contains(cur) ||
						!$(cur).is('input, textarea, select')
					)
					&& self.focusedInput
				)
					self.restoreFocus();

			}, 450);
		});

		// Если вкладка возвращается, попробуем восстановить
		document.addEventListener('visibilitychange', function () {
			if (
				!document.hidden &&
				self.focusedInput
			)
				setTimeout(() => self.restoreFocus(), 200);
		});
	}

	//-------------------------------------------------
	// Восстановление фокуса
	restoreFocus() {
		if (
			!this.focusedInput ||
			!this.focusedInput.length
		)
			return false;

		const native = this.focusedInput[0];

		if (
			!document.contains(native) ||
			!native.offsetParent ||
			native.disabled
		) {
			this.focusedInput = null;

			return false;
		}

		native.focus();

		// Если фокус не установился — прокрутить, кликнуть и ещё раз сфокусировать
		setTimeout(() => {
			if (document.activeElement !== native) {
				native.scrollIntoView({block: 'center', behavior: 'smooth'});
				native.focus();
			}
		}, 120);

		return true;
	}

	//-------------------------------------------------
	//Восстановить countdown из localStorage
	restoreCountdown() {
		if (
			!this.countdownId ||
			!this.countdownSeconds
		) return;

		var
			stored = localStorage.getItem(this.countdownId);

		if (stored && parseInt(stored) > 0) {
			this.$resetRow.show();
			this.startCountdown(parseInt(stored));
		}
	}

	//-------------------------------------------------
	//Запустить обратный отсчёт
	startCountdown(seconds = null) {
		if (
			!this.$countdown.length ||
			!this.countdownSeconds
		) return;

		var
			duration = seconds || this.countdownSeconds;

		this.$countdown.show();
		this.countdownIsActive = true;

		planb.countdown(
			this.countdownId,
			duration,
			() => this.stopCountdown()
		);
	}

	//-------------------------------------------------
	//Остановить обратный отсчёт
	stopCountdown() {
		if (!this.$countdown.length)
			return;

		this.$countdown.hide();
		this.countdownIsActive = false;

		if (
			!this.$reset.is(':visible') &&
			!this.confirmed
		)
			this.$resetRow.hide();

		if (this.confirmed)
			this.$resend.show();

		localStorage.removeItem(this.countdownId);
	}


	showError(error) {
		this.$error
			.html(error)
			.addClass('active')
			.fadeIn(100);

		setTimeout(() => {
			this.$error
				.html('')
				.fadeOut(100, function () {
					$(this).removeClass('active');
				});
		}, 3000);
	}

	//-------------------------------------------------
	//Проверка промокода
	async checkPromocode() {
		// console.clear();
		var self = this,
			$codeField = this.$inputs.filter('[name="promocode"]'),
			$loginField = this.$inputs.filter('[name="login"]');

		let promocodeField = self.$form.find('.register-promocode');
		promocodeField.removeClass('error ok');

		if ($codeField.length == 0)
			return true;

		var login = $loginField.val().trim();
		var code = $codeField.val().trim();
		if (!code)
			return true;

		if (!login)
			return true;



		let isValid = true;
		$.ajax({
			url: '/local/ajax/forms/personal.promocode.php',
			type: 'POST',
			cache: false,
			async: false,//делаем синхронный запрос
			data: {
				code: code,
				login: login
			},
			success: async function (result) {
				try {
					result = JSON.parse(result);
					// console.dir(result);

					if (result.error != '') {
						isValid = false;
						promocodeField.addClass('error');
						promocodeField.find('.register-promocode__field-error').html(result.error);
					}
					else {
						promocodeField.addClass('ok');
						$codeField.prop('disabled', true);
					}
				} catch (error) {
					self.logError(error, result, 'checkPromocode error');
					self.changeButtonActive(false);
				}
			},
		});
		// if (isValid)
		// 	await delay(1000);



		return isValid;
	}
}